<template>
<span style="width:100%">
    <label-input
         v-bind="$attrs"
         v-on="$listeners"
         :label="label"
         :isZero="isZero"
    />
    <span class="text" v-text="text"></span>
</span>
        
</template>

<script>
import LabelInput from "@/components/label-input-v2/input";
export default {

  components: { LabelInput },
  props: {
    inputWidth: {
        required: false,
        default: ''
    }, 
    searchData: {
        type: Array,
        required: false,
        default: function() {
            return []
        }
    },
    form: {
        type: Object,
        require: true,
        default: function() {
            return {}
        }
    },
    label: {
        type: String,
        require: false,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    maxleng: {
        type: Number,
        default: 4
    }
  },
  data() {
    return {
      searchList: [],
      isShowList: false,
      loading: false,
      isZero: false,
    };
  },
  watch: {
   $attrs: {
       handler(value) {
            if(value.value === 0) {
                this.isZero = true
            }
       }
   }
  },
  methods: {
      
  },
  mounted() {
      //禁用回车
      document.onkeydown = function(event) {
            let target, code, tag;
            if (!event) {
                event = window.event; 
                target = event.srcElement;
                code = event.keyCode;
                if (code == 13) {
                    tag = target.tagName;
                    if (tag == "TEXTAREA") { return true; }
                    else { return false; }
                }
            }
            else {
                target = event.target;
                code = event.keyCode;
                if (code == 13) {
                    tag = target.tagName;
                    if (tag == "INPUT") { return false; }
                    else { return true; }
                }
            }
    };
  },
  
};
</script>

<style lang="scss" scoped>
span {
    position: relative;
    display: inline-block;
}
.text {
    position: absolute;
    right: 12px;
    top: 6px;
    font-weight: 500;
    font-size: 14px;
    color: #7f8596;
}
.el-form-item {
    margin-bottom: 0 !important;
}
 img{
    position: absolute;
    top: 12px;
    right: 12px;
}
.content {
    width: 100%;
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 2px;
    margin-top: 4px;
    transition: .5s;
    position: relative;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    p {
        font-size: 12px;
        height: 40px;
        width: 100%;
        padding: 0 12px;
        line-height: 40px;
        background: #fff;
        cursor: pointer;
    }
    p:hover {
        background-color: #f6f7f9;
    }
    img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        animation: Rotation 1s linear infinite ;
        @keyframes Rotation {
            from {
                -webkit-transform: rotate(0deg);
            }
            to {
                -webkit-transform: rotate(360deg);
            }
        }
    }
}
.none {
    height: 0;
    transition: .5s;
}
</style>
